import {Component, OnInit} from '@angular/core';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {IntelligenceService} from '../../../services/intelligence.service';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-weee-treatment-standard-mandatory',
  templateUrl: './weee-treatment-standard-mandatory.component.html',
  styleUrls: ['./weee-treatment-standard-mandatory.component.scss']
})
export class WeeeTreatmentStandardMandatoryComponent implements OnInit {

  text = 'Mandatory WEEE treatment standards';
  subtitle = '';
  data!: IntelligenceData[];

  constructor(private readonly intelligenceService: IntelligenceService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.intelligenceService.getStandardMandatory(search).subscribe(response => {
        this.data = response;
      });
    });
  }

  searchData(event: IntelligenceSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
